import React from "react";
import styled from "styled-components";
import searchIcon from "../../assets/images/ico_search.png";

const StyledButton = styled.button`
  display: inline-block;
  margin: 0 10px;
  border: none;
  cursor: pointer;

  img {
    vertical-align: middle;
  }
`;

const SearchButton = ({ onClick }) => {
  return (
    <StyledButton onClick={onClick} aria-label="Search">
      <img src={searchIcon} alt="Search" />
    </StyledButton>
  );
};

export default SearchButton;
